<template>
  <span class="links-list">
    <span v-for="l in linked" :key="l.key">
        <router-link v-if="l.type === 'project'" :to="{name:'projectsDetail', params: {id: l.id}}">{{ l.label }}</router-link>
        <router-link v-if="l.type === 'task'" :to="{name:'tasksDetail', params: {id: l.id}}">{{ l.label }}</router-link>
    </span>
  </span>
</template>

<script>
import ResettableTimeout from 'CORE/utils/resettable-timeout'
import DataTypeProsMixin from 'CORE/mixins/dataType'
import ResourceLabel from 'CORE/components/resource/label'
import _ from 'lodash'
import labels from 'CORE/utils/labels'

const transformLinkable = l => {
    return {
        id: _.get(l, 'id'),
        label: _.isPlainObject(_.get(l, 'projectType', false)) ? labels.project(l) : labels.task(l),
        type: _.get(l, 'projectType', false) ? 'project' : 'task',
    }
}

export default {
    name: 'LinkDetail',
    components: {
        ResourceLabel,
    },
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        linkables() {
            return _.map(
                [...this.$store.getters.projects, ...this.$store.getters.tasks],
                transformLinkable
            )
        },
        linked() {
            return _.filter(this.linkables, l => {
                if (_.indexOf(this.value.value.value, l.id) >= 0) return true
                return false
            })
        }
    },
}
</script>

<style scoped>
.links-list {
    display: flex;
    flex-direction: column;
}
.links-list a {
    white-space: nowrap;
    display: block;
}
</style>
